import { render } from "./InnerFieldsForm.vue?vue&type=template&id=2d39a230"
import script from "./InnerFieldsForm.vue?vue&type=script&lang=js"
export * from "./InnerFieldsForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Intermark\\Intermark(mobile)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__